import ContractTelecomButtonCp from "./ContractTelecomButtonCp";
import plans from "../../interfaces/telecomPlans.json";
import React from 'react';
import './TelecomPlans.css'

function TelecomPlans(): React.JSX.Element {

    return (
        <>
            {plans.telecomPlans.map(item => (
                <div className="container">
                    <div className="planName">
                        <p className="planName">{item.planName}</p>
                    </div>
                    <div className="planGigas">
                        <p id="planGigas">{item.planGb}</p>
                    </div>
                    <div className="planBenefits">
                        {item.planBenefits.map((benefit, id) => (
                            <p key={id}>{benefit}</p>
                        ))}
                    </div>
                    <div>
                        <p className="planPrice">R${item.planValue}/mês</p>
                    </div>
                    <div className="contractButton">
                        <ContractTelecomButtonCp />
                    </div>
                </div>
            ))}

        </>
    );
}

export default TelecomPlans;